import {
  POST_GET_ALL_SERIES_REQUEST,
  POST_GET_ALL_SERIES_SUCCESS,
  POST_GET_ALL_SERIES_ERROR,
  POST_UNRESERVE_MARKING_CODE_REQUEST,
  POST_UNRESERVE_MARKING_CODE_SUCCESS,
  POST_UNRESERVE_MARKING_CODE_ERROR,
  POST_GET_SERIES_DETAILED_REQUEST,
  POST_GET_SERIES_DETAILED_SUCCESS,
  POST_GET_SERIES_DETAILED_ERROR,
  CLOSE_ERROR_POPUP_SERIES,
} from './constants';

export const postGetAllSeriesRequest = (body: any) => ({
  type: POST_GET_ALL_SERIES_REQUEST,
  payload: body,
});
export const postGetAllSeriesSuccess = (response: any) => ({
  type: POST_GET_ALL_SERIES_SUCCESS,
  payload: response,
});
export const postGetAllSeriesError = (error: any) => ({
  type: POST_GET_ALL_SERIES_ERROR,
  payload: error,
});

export const postUnreserveMarkingCodeRequest = (body: any) => ({
  type: POST_UNRESERVE_MARKING_CODE_REQUEST,
  payload: body,
});
export const postUnreserveMarkingCodeSuccess = (response: any) => ({
  type: POST_UNRESERVE_MARKING_CODE_SUCCESS,
  payload: response,
});
export const postUnreserveMarkingCodeError = (error: any) => ({
  type: POST_UNRESERVE_MARKING_CODE_ERROR,
  payload: error,
});

export const postGetSeriesDetailedRequest = (body: any) => ({
  type: POST_GET_SERIES_DETAILED_REQUEST,
  payload: body,
});
export const postGetSeriesDetailedSuccess = (response: any) => ({
  type: POST_GET_SERIES_DETAILED_SUCCESS,
  payload: response,
});
export const postGetSeriesDetailedError = (error: any) => ({
  type: POST_GET_SERIES_DETAILED_ERROR,
  payload: error,
});

export const closeErrorPopUpSeries = () => ({
  type: CLOSE_ERROR_POPUP_SERIES,
});

export type Actions =
  | ReturnType<typeof postGetSeriesDetailedRequest>
  | ReturnType<typeof postGetSeriesDetailedSuccess>
  | ReturnType<typeof postGetSeriesDetailedError>
  | ReturnType<typeof postGetAllSeriesRequest>
  | ReturnType<typeof postGetAllSeriesSuccess>
  | ReturnType<typeof postGetAllSeriesError>
  | ReturnType<typeof postUnreserveMarkingCodeRequest>
  | ReturnType<typeof postUnreserveMarkingCodeSuccess>
  | ReturnType<typeof postUnreserveMarkingCodeError>
  | ReturnType<typeof closeErrorPopUpSeries>;
